import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute, NavigationExtras} from '@angular/router';

@Component({
  selector: 'app-reset-password-success',
  templateUrl: './reset-password-success.page.html',
  styleUrls: ['./reset-password-success.page.scss'],
})
export class ResetPasswordSuccessPage implements OnInit {

  navigationExtras: any;
  
  constructor(
  	private router: Router) {
  	this.navigationExtras = this.router.getCurrentNavigation().extras;
  }

  ngOnInit() {
  }

  gotoLoginPage() {
        this.router.navigate(['/login'], this.navigationExtras);
  }


}
